'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var GridToolbarConfigurationMarketClassFareController = function GridToolbarConfigurationMarketClassFareController($scope, $rootScope, $q, toolbarGridService, featureToggleService) {
  $scope.selectedRows = [];
  $scope.areEditingButtonsShown = !hasFileFareUpload();
  function hasRowModification(row) {
    return row._old;
  }
  function transformEntry(entry) {
    return {
      origin: entry.origin || '',
      destination: entry.destination || '',
      fareClass: entry["class"] || '',
      effectiveDate: entry.effectiveDate ? entry.effectiveDate.toISOString() : '',
      discontinueDate: entry.discontinueDate ? entry.discontinueDate.toISOString() : ''
    };
  }
  function isDuplicate(entry, allRows) {
    var fieldsToCheck = transformEntry(entry);
    var rowsIdenticalToModified = _.chain(allRows).transform(function (result, entry) {
      var newEntry = transformEntry(entry);
      return result.push(newEntry);
    }).filter(fieldsToCheck).value().length;
    return rowsIdenticalToModified > 1;
  }
  function doesRowContainEmptyField(entry) {
    return !entry.origin || !entry.destination || !entry["class"] || !entry.effectiveDate || !entry.discontinueDate || !entry.fare;
  }
  function validate(modifiedRows, allRows) {
    var promise = $q.defer();
    var isValidDuplicate = true;
    var isValidEmptyRow = true;
    var errorMessages = [];
    for (var i = 0; i < modifiedRows.length; i++) {
      if (!_.isUndefined(modifiedRows[i].origin) && modifiedRows[i].origin === modifiedRows[i].destination) {
        isValidDuplicate = false;
        errorMessages.push('Market Origin and Market Destination should not be same.');
      }
      if (isDuplicate(modifiedRows[i], allRows) && isValidDuplicate) {
        isValidDuplicate = false;
        errorMessages.push('Duplicate record exists');
      }
      if (doesRowContainEmptyField(modifiedRows[i]) && isValidEmptyRow) {
        isValidEmptyRow = false;
        errorMessages.push('Every column has to be filled');
      }
    }
    if (isValidDuplicate && isValidEmptyRow) {
      promise.resolve(modifiedRows);
    } else {
      promise.reject(errorMessages);
    }
    return promise.promise;
  }
  function validationSuccess(rows) {
    $scope.$emit('configuration-market-class-fare-grid:saveChanges', rows);
  }
  function validationFailure(messages) {
    for (var i = 0; i < messages.length; i++) {
      toastr.error(messages[i]);
    }
  }
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDeleteButtonShown = selectedRows.length > 0 && !hasFileFareUpload();
    $scope.isDuplicateButtonShown = selectedRows.length === 1 && !hasFileFareUpload();
    $scope.selectedRows = selectedRows;
  };
  $scope.saveChanges = function () {
    var allRows = $scope.jqxGridSettings.source.loadedData;
    var rows = _.chain(allRows).filter(hasRowModification).clone(true).value(true);
    if (!_.isEmpty(rowsToRemoveFromServer)) {
      $scope.$emit('configuration-market-class-fare-grid:removeFromServer', rowsToRemoveFromServer);
      rowsToRemoveFromServer = [];
    }
    if (rows.length > 0) {
      validate(rows, allRows).then(validationSuccess, validationFailure);
    } else {
      $scope.clearModifiedCells();
    }
  };
  function setStructureWithOldValues(loadedData, rowid) {
    loadedData[rowid]._old = {};
    var columns = $scope.jqxGridSettings.columns;
    _.forEach(columns, function (col) {
      loadedData[rowid]._old[col.datafield] = undefined;
    });
  }
  $scope.addMarketClassFare = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    loadedData.unshift({
      isNewlyAdded: true
    });
    setStructureWithOldValues(loadedData, 0);
    $scope.updateData(loadedData);
  };
  $scope.duplicateMarketClassFare = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var rowId = $scope.jqxGridSettings.jqxGrid('getselectedrowindex');
    var oldRow = loadedData[rowId];
    var newRow = _.clone(oldRow);
    newRow.isRowEditable = true;
    loadedData.splice(rowId, 0, newRow);
    setStructureWithOldValues(loadedData, rowId);
    $scope.updateData(loadedData);
  };
  var rowsToRemoveFromServer = [];
  $scope.removeFares = function () {
    var loadedData = $scope.jqxGridSettings.source.loadedData;
    var selectedIndexes = $scope.jqxGridSettings.jqxGrid('getselectedrowindexes');
    for (var i = 0; i < selectedIndexes.length; i++) {
      var row = loadedData[selectedIndexes[i]];
      if (!row.isRowEditable && !row.isNewlyAdded) {
        rowsToRemoveFromServer.push(row);
      }
    }
    toolbarGridService.removeRow($scope);
  };
  $scope["import"] = function () {
    $scope.isImportValidationError = false;
    $rootScope.$broadcast('grid:showImportModal', $scope.gridId);
  };
  $scope["export"] = function () {
    $scope.asyncGridApply('getdisplayrows').then(function (data) {
      $scope.$emit('configuration-market-class-fare-grid:export', data);
    });
  };
  $scope.$on('configuration-market-class-fare-grid:saveSuccess', function () {
    $scope.clearModifiedCells();
  });
  function hasFileFareUpload() {
    return featureToggleService.isDisabled('FIM') && featureToggleService.isEnabled('SERVICE_CLASS_CONTROL');
  }
};
GridToolbarConfigurationMarketClassFareController.$inject = ['$scope', '$rootScope', '$q', 'ToolbarGridService', 'FeatureToggleService'];
module.exports = GridToolbarConfigurationMarketClassFareController;